export enum TipoComportamentoWhatsApp {
    RESPOSTA_AUTOMATICA_IA = "RESPOSTA_AUTOMATICA_IA",
    RESPOSTA_AUTOMATICA_SIMPLES = "RESPOSTA_AUTOMATICA_SIMPLES",
    RESPOSTA_AUTOMATICA_HIBRIDA = "RESPOSTA_AUTOMATICA_HIBRIDA",
    ATUALIZACOES_PEDIDO = "ATUALIZACOES_PEDIDO",
    ATUALIZACOES_KDS = "ATUALIZACOES_KDS",
    RESGATE_PEDIDO_PERDIDO = "RESGATE_PEDIDO_PERDIDO",
    PEDIDO_AVALIACAO = "PEDIDO_AVALIACAO"
}

export enum TipoComportamentoWhatsAppDescricao {
    RESPOSTA_AUTOMATICA_IA = "Resposta automática com IA",
    RESPOSTA_AUTOMATICA_SIMPLES = "Resposta automática simples",
    RESPOSTA_AUTOMATICA_HIBRIDA = "Resposta automática híbrida",
    ATUALIZACOES_PEDIDO = "Atualizações de pedido",
    ATUALIZACOES_KDS = "Atualizações KDS",
    RESGATE_PEDIDO_PERDIDO = "Resgate de pedido perdido",
    PEDIDO_AVALIACAO = "Pedido de avaliação"
}